"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValueByDate = exports.getRowLabelsLayout = exports.getRectLayout = void 0;
const lodash_1 = __importDefault(require("lodash"));
const colors_1 = require("../../utilities/colors");
const constants_1 = require("../../utilities/constants");
const constants_2 = require("./constants");
const createSubgroupReducer = (x, y, height, width, proportionsBySubgroup, expanded, group, category, categoryTotal, xOffset, categoryColor) => (subgroupArray, _ref) => {
  let {
    name: label,
    id: metric,
    color: subcategoryColor = categoryColor
  } = _ref;
  if (!expanded) {
    return lodash_1.default.concat(subgroupArray, {
      x: xOffset,
      y,
      height,
      width: 0,
      group,
      category,
      metric,
      label,
      color: subcategoryColor
    });
  }
  let subgroupX;
  const subgroupWidth = categoryTotal ? proportionsBySubgroup[metric] / categoryTotal * width : 0;
  if (lodash_1.default.isEmpty(subgroupArray)) {
    subgroupX = x;
  } else {
    const previousSubgroup = lodash_1.default.last(subgroupArray);
    subgroupX = previousSubgroup.x + previousSubgroup.width + constants_2.RECT_PADDING_X;
  }
  return lodash_1.default.concat(subgroupArray, {
    x: subgroupX,
    y,
    height,
    width: subgroupWidth,
    group,
    category,
    metric,
    label,
    color: subcategoryColor
  });
};
const createGroupingReducer = function (y, height, totalWidth, selectedCategories, metricsByGroupByCategory, proportionsBySubgroup, group, groupProportion) {
  let leftMargin = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
  return (array, _ref2, i) => {
    let {
      id: category,
      label,
      color
    } = _ref2;
    let x = 0;
    const categoryColor = color || colors_1.DEFAULT_COLORS[i % colors_1.DEFAULT_COLORS.length];
    const categoryProportion = (0, lodash_1.default)(proportionsBySubgroup[category]).map(lodash_1.default.identity).sum();
    const expanded = lodash_1.default.includes(selectedCategories, category);
    const width = Math.max(0, groupProportion ? categoryProportion / groupProportion * totalWidth : 0);
    if (lodash_1.default.isEmpty(array)) {
      x = leftMargin;
    } else {
      const previousGroup = lodash_1.default.last(array);
      x = previousGroup.x + previousGroup.width + constants_2.RECT_PADDING_X;
    }
    const xOffset = expanded ? x : x + width;
    const subgroupRects = metricsByGroupByCategory[category].reduce(createSubgroupReducer(x, y, height, width - (metricsByGroupByCategory[category].length - 1) * constants_2.RECT_PADDING_X, proportionsBySubgroup[category], expanded, group, category, categoryProportion, xOffset, categoryColor), []);
    return lodash_1.default.concat(array, {
      x,
      y,
      height,
      width: expanded ? 0 : width,
      group,
      category,
      metric: null,
      label,
      color: categoryColor
    }, subgroupRects);
  };
};
const getRectLayout = function (groups, categories, totalHeight, totalWidth, selectedCategories, metricsByGroupByCategory, proportionsBySubgroup) {
  let leftMargin = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
  return groups.reduce((array, _ref3) => {
    let {
      id: group
    } = _ref3;
    let y;
    const groupProportion = (0, lodash_1.default)(proportionsBySubgroup[group]).flatMap(categories => lodash_1.default.map(categories, lodash_1.default.identity)).sum();
    const height = groupProportion * totalHeight;
    if (lodash_1.default.isEmpty(array)) {
      y = 0;
    } else {
      const previousEntry = lodash_1.default.last(array);
      const padding = previousEntry.height > 0 ? constants_2.RECT_PADDING_Y : 0;
      y = previousEntry.height + previousEntry.y + padding;
    }
    const rects = (0, lodash_1.default)(categories).reduce(createGroupingReducer(y, height, totalWidth, selectedCategories, metricsByGroupByCategory[group], proportionsBySubgroup[group], group, groupProportion, leftMargin), []);
    return lodash_1.default.concat(array, rects);
  }, []);
};
exports.getRectLayout = getRectLayout;
const getRowLabelsLayout = (groups, proportionsByGroup, totalHeight, marginY, fontSize) => groups.reduce((array, _ref4) => {
  let {
    id,
    label
  } = _ref4;
  let y;
  const yPadding = 2;
  const rowHeight = proportionsByGroup[id] * totalHeight;
  // If row is empty set height to 0 and don't show, else it needs to be at least as tall as font + padding
  const labelHeight = proportionsByGroup[id] === 0 ? 0 : Math.max(fontSize + yPadding, rowHeight + marginY);
  if (lodash_1.default.isEmpty(array)) {
    y = 0;
  } else {
    const previousEntry = lodash_1.default.last(array);
    y = previousEntry.height + previousEntry.y;
  }
  // If smaller than text height but more than 0, center text instead of having it at top.
  if (rowHeight < fontSize && proportionsByGroup[id] > 0) {
    y += rowHeight / 2 - fontSize * constants_1.FONT_VERTICAL_CENTER_OFFSET_RATIO;
  }
  return lodash_1.default.concat(array, {
    y,
    height: labelHeight,
    group: id,
    label
  });
}, []);
exports.getRowLabelsLayout = getRowLabelsLayout;
const getValueByDate = date => _ref5 => {
  let {
    data: values
  } = _ref5;
  const {
    value
  } = values.find(_ref6 => {
    let {
      key
    } = _ref6;
    return key === date;
  }) || {};
  return value || 0;
};
exports.getValueByDate = getValueByDate;